import { absoluteURL } from "./UrlHelper";

export const formatUmbracoMedia = (mediaUrl?: string) =>
{
    if (mediaUrl && mediaUrl.startsWith("/media/"))
    {
        return mediaUrl.replace("/media/", absoluteURL("/media/"));
    }
    return "";
};